import React, { memo } from "react";
import Switch from "@ui/Switch";
import t from "../../../../../../../../../i18n";
import { useGUIEditorContext } from "../../../../../../hook/context/gui";
import { useBlockOptionUpdateCallback } from "../hook/useOptionUpdateCallback";

export const DisplayInvalidatedDataPointsToggle = memo(() => {
  const { block } = useGUIEditorContext();
  const updateBlockOption = useBlockOptionUpdateCallback();

  return (
    <Switch
      checked={block?.config.options?.displayInvalidatedDataPoints ?? false}
      onChange={event => updateBlockOption("displayInvalidatedDataPoints", event.target.checked)}
    >
      {t("project.dashboard.editor.gui.section.display.invalidated_data_points")}
    </Switch>
  );
});
